import * as React from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Link,
  Typography,
  Popper,
  Button,
  TextField,
  Checkbox,
} from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from '@material-ui/core/ListItemIcon'
// import ListItemText from '@material-ui/core/ListItemText'
// import LinkIcon from '@material-ui/icons/Link'
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import LinkIcon from "@mui/icons-material/Link";
import SendIcon from "@mui/icons-material/Send";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ProfessionalCovenants from "src/Professional/ProfessionalCovenants";
import ProfessionalName from "src/Professional/ProfessionalName";
// import ProfessionalPhoto from "src/Professional/ProfessionalPhoto";
import ProfessionalSpecialities from "src/Professional/ProfessionalSpecialities";
import { cardBase, cardHeader } from "src/shared/styles/cardStyles";
import {
  capitalizeWord,
  serializeDateFormatLong,
} from "src/shared/global/helpers";
import { useRecoilCallback, useSetRecoilState } from "recoil";
//import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil';
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";

import {
  reservationForCancelSelectedState,
  showModalCancelReservationState,
} from "../state/atoms";

import {
  sendEmailFetchState,
  sendEmailState,
  readFileTextFetchState,
} from "../../../Patient/state/atoms";

import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

import Fab from "@mui/material/Fab";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ImageSearchOutlinedIcon from "@mui/icons-material/ImageSearchOutlined";
import ShareIcon from "@mui/icons-material/Share";

import { snackbarState } from "src/store/global/snackbarState";

import _raw from "./data.txt";

const ListShareSocial = ({ url }) => {
  const handleListItemClick = (url) => {
    console.log("handleListItemClick ", url);
    navigator.clipboard.writeText("COPIAR TEXTO! ");
  };

  return (
    <List dense={true}>
      <ListItemButton
        onClick={() => {
          navigator.clipboard.writeText(url);
        }}
      >
        <ListItemIcon>
          <LinkIcon />
        </ListItemIcon>
        <ListItemText primary="Copiar Link" />
      </ListItemButton>
      <ListItemButton
        onClick={() => {
          window.location.href =
            "mailto:test@example.com?subject=Compartir Imagenologia&body=" +
            url;
        }}
      >
        <ListItemIcon>
          <SendIcon />
        </ListItemIcon>
        <ListItemText primary="Mail" />
      </ListItemButton>

      {/* <ListItemButton onClick={() => {
                    console.log("https://api.whatsapp.com/send?text="+url);
                     let myURL = "https://api.whatsapp.com/send?text=HOla Mundo!!!";    
                     window.open(myURL, '_blank');               
                  }}>
        <ListItemIcon>
          <WhatsAppIcon />
        </ListItemIcon>
        <ListItemText primary="Whatsapp" />
      </ListItemButton>       */}
    </List>
  );
};

const DialogShareSocial = ({ url, urlImg, nameDoc, dateExam }) => {
  const textFieldRef = React.useRef();
  const [checked, setChecked] = React.useState(false);

  const { catchErrorApi } = useCatchErrorApi();
  const setSnackbar = useSetRecoilState(snackbarState);

  const [openDialog, setOpenDialog] = React.useState(false);
  // const [value, setValue] = React.useState('');
  const [tfValue, setTFValue] = React.useState("");
  //const [valuesFormRegister, setValuesFormRegister] = useRecoilState(sendEmailState);
  const handleClickOpen = () => {
    setOpenDialog(true);
    //setChecked(false);
  };

  const handleClose = async () => {
    setOpenDialog(false);
    console.log("TEXTO Close = ", url);
  };

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const handleCloseCallback = useRecoilCallback(
    ({ snapshot }) =>
      async (varMail, varChecked) => {
        //setLoading(true)

        if (varMail == "") {
          console.log("Favor ingresar mail.");
          //catchErrorApi("Favor ingresar mail.");
          setSnackbar({
            openAlert: true,
            severity: "error",
            text: "Favor ingresar mail.",
            position: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
          return false;
        }
        console.log("MAIL --> ", varMail);

        if(validateEmail(varMail)){
          console.log(varMail + ' is valid.')
        } else{
          setSnackbar({
            openAlert: true,
            severity: "error",
            text: "Correo electrónico inválido",
            position: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
          return false;
        }

        console.log("VALIDAR CHECK => ", varChecked);
        if (varChecked === false) {
          console.log("Favor aceptar termino y condiciones.");
          //catchErrorApi("Favor ingresar mail.");
          setSnackbar({
            openAlert: true,
            severity: "error",
            text: "Favor aceptar termino y condiciones.",
            position: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
          return false;
        }

        setOpenDialog(false);
        console.log("HOLA!!!", varMail);

        let htmlText = await snapshot.getPromise(readFileTextFetchState());
        //console.log(htmlText);

        let htmlBody = htmlText.replace("${desc_examen}", nameDoc);
        htmlBody = htmlBody.replace("${url}", url);
        htmlBody = htmlBody.replace("${urlImg}", urlImg);
        htmlBody = htmlBody.replace("${fecha}", dateExam);
        //console.log(url);

        let body = {
          to: varMail,
          body: htmlBody,
          subject: "Resultados de Informes Imagenología Andes Salud",
        };
        console.log(body);

        try {
          const resultado = await snapshot.getPromise(
            sendEmailFetchState(body)
          );
          console.log(resultado);
          setSnackbar({
            openAlert: true,
            severity: "success",
            text: "Su examen ha sido enviado con éxito.",
            position: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        } catch (error) {
          console.log("ERROR => ", error);
          setSnackbar({
            openAlert: true,
            severity: "error",
            text: "El mail no se a podido enviar, Vuelve a intentarlo más tarde.",
            position: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        } finally {
          //setLoading(false)
          setTFValue("");
          setChecked(false);
        }
      },
    []
  );

  const handleChange = (event) => {
    //console.log('CHECK => ',checked);
    //console.log(event.target.checked);

    // if(event.target.checked === false) {
    //   setChecked(false);
    // }else{
    //   setChecked(false);
    // }
    setChecked(event.target.checked);

    //console.log('CHECK => ',checked);
  };

  return (
    <>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
      Open form dialog
    </Button> */}
      <Fab
        variant="extended"
        size="small"
        color="primary"
        aria-label="add"
        // href={professional?.rutaDocumento}
        // target="_blank"
        onClick={handleClickOpen}
      >
        <ShareIcon sx={{ mr: 1 }} />
        COMPARTIR
      </Fab>{" "}
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle>Resultados Exámenes</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ingrese su dirección de correo electrónico aquí. Nosotros
            compartiremos su examen de imagenología.
          </DialogContentText>
          <TextField
            onChange={(newValue) => setTFValue(newValue.target.value)}
            id="filled-1"
            variant="standard"
            placeholder="mail@dominio.cl"
            label="Correo electrónico"
            type="email"
            fullWidth
            value={tfValue}
          />
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={1} justifyContent="center" alignItems="center">
              <Checkbox
                id="chckbox1"
                checked={checked}
                onChange={handleChange}
                //onCheck={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Grid>
            <Grid item xs={8} style={{ textAlign: "left", paddingTop: "5px" }}>
              <Typography
                paddingY={1}
                style={{ fontWeight: "bold", fontSize: 12 }}
              >
                Declaro conocer y aceptar los
                <Link
                  href="https://risla2.amis-rx.cl:1443/PPAC/PdfTerminosCondiciones/terminoCondiciones.pdf"
                  target="_blank"
                  rel="noopener"
                >
                  {" "}
                  Terminos y Condiciones de uso.
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            onClick={() => {
              //console.log("HOLA!!!", tfValue);
              console.log("CHECK!!!", checked);
              handleCloseCallback(tfValue, checked);
            }}
          >
            Enviar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const ChildrenHeaderCard = ({ fecha }) => {
  return (
    <>
      <Typography
        style={{
          fontWeight: 600,
          fontSize: 12,
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <CalendarTodayIcon
          style={{
            fontWeight: 600,
            fontSize: 12,
            marginRight: 10,
          }}
        />{" "}
        {fecha.split(" ")[1].substring(0, 5)} / {fecha.split(" ")[0]}
      </Typography>
    </>
  );
};

const CardExam = ({ professional, cancelReservation = true }) => {
  const theme = useTheme();
  const isMediaScreen = useMediaQuery(theme.breakpoints.up("md"));

  const setShowModalCancelReservation = useSetRecoilState(
    showModalCancelReservationState
  );
  const setReservationForCancelSelected = useSetRecoilState(
    reservationForCancelSelectedState
  );

  const handleOpenModal = () => {
    setShowModalCancelReservation(true);
    setReservationForCancelSelected(professional);
  };

  //-------

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  //-------

  //-------

  return (
    <Card sx={{ ...cardBase }}>
      <CardHeader
        style={{ ...cardHeader }}
        title={<ChildrenHeaderCard fecha={professional?.fechaExamen} />}
      />
      <CardContent style={{ backgroundColor: "#F9FAFB" }}>
        <Grid
          style={{
            display: "flex",
            alignItems: !isMediaScreen ? "flex-start" : "center",
          }}
        >
          {/* <ProfessionalPhoto image={professional.imagen} alt={professional.ptdNombre} /> */}

          <Grid item md={12} ml={2}>
            <Grid item md={12}>
              <ProfessionalName
                nameProfessional={professional.nombreDocumento}
              />
              <ProfessionalSpecialities specialities={professional.nombre} />
            </Grid>

            <Typography
              paddingY={1}
              style={{ fontWeight: "bold", fontSize: 12 }}
            >
              Adjunto:
            </Typography>

            <Grid container spacing={1} mt={1}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="baseline"
              >
                {/* <Typography style={{ fontWeight: 500, fontSize: 12 }}>
                  {professional?.idInforme?.replace(",", ".") ||
                    "No especificado"}
                </Typography>
                <Typography style={{ fontWeight: 500, fontSize: 12 }}>
                  {professional?.fechaExamen}
                </Typography> */}
                <Fab
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="add"
                  href={professional?.rutaDocumento}
                  target="_blank"
                >
                  <DescriptionOutlinedIcon sx={{ mr: 1 }} />
                  DOCUMENTO
                </Fab>
                <>&nbsp;</>
                <Fab
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="add"
                  href={professional?.rutaImagen}
                  target="_blank"
                >
                  <ImageSearchOutlinedIcon sx={{ mr: 1 }} />
                  IMAGEN
                </Fab>
                <>&nbsp;</>
                <DialogShareSocial
                  url={professional?.rutaDocumento}
                  urlImg={professional?.rutaImagen}
                  nameDoc={professional?.nombreDocumento}
                  dateExam={professional?.fechaExamen}
                />
              </Grid>

              {/* <Fab
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={handleClick}
                >
                  <ShareIcon sx={{ mr: 1 }} />
                  COMPARTIR IMAGEN
                </Fab> 
              <Popper id={id} open={open} anchorEl={anchorEl}>
                  <Box sx={{ border: 0.5, p: 1, bgcolor: "background.paper" }}>
                    <ListShareSocial url={professional?.rutaImagen}/>
                  </Box>
                </Popper>
              */}
              {/* <a href="https://api.whatsapp.com/send?text=Aprendiendo a compartir desde web">Compartir en WhatsApp</a> */}

              {/* <a href="mailto:test@example.com?subject=Testing out mailto!&body=This is only a test!">Second Example</a> */}

              {/* <Grid item xs={12} md={9} mt={!isMediaScreen ? 2 : 0}>
                                <ProfessionalCovenants covenants={professional.convenios} />
                            </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      {cancelReservation && (
        <CardActions style={{ padding: 16 }}>
          <Link
            style={{
              textDecoration: "none",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "18px",
            }}
            component="button"
            variant="body2"
            color="error"
            onClick={handleOpenModal}
          >
            Anular reserva
          </Link>
        </CardActions>
      )}
    </Card>
  );
};

export default CardExam;
